import { render, staticRenderFns } from "./DemoCallUser.vue?vue&type=template&id=598a5b3a&"
import script from "./DemoCallUser.vue?vue&type=script&lang=js&"
export * from "./DemoCallUser.vue?vue&type=script&lang=js&"
import style0 from "./DemoCallUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports